import { VipList } from "../../../pages/Vip/vipList";

export const storeMemberInfo = (data) => {
  return {
    type: "storeMemberInfo",
    payload: data,
  };
};
export const cleanMemberInfo = () => {
  return {
    type: "cleanMemberInfo",
  };
};
export const StoreCryptoRatio = (data) => {
  return {
    type: "StoreCryptoRatio",
    payload: data,
  };
};
export const storeReferDetail = (data) => {
  return {
    type: "storeReferDetail",
    payload: data,
  };
};
export const openLanguagePop = () => {
  return {
    type: "openLanguagePop",
  };
};
export const closeLanguagePop = () => {
  return {
    type: "closeLanguagePop",
  };
};
export const openComissionListPop = () => {
  return {
    type: "openComissionListPop",
  };
};
export const closeComissionListPop = () => {
  return {
    type: "closeComissionListPop",
  };
};
export const uploadFile = (file) => {
  return {
    type: "uploadFile",
    payload: file,
  };
};
export const storeTransferWallet = (wallet) => {
  return {
    type: "storeTransferWallet",
    payload: wallet,
  };
};
export const storeVipDetail = (vipDetail) => {
  const mockData = [
    {
      vipLevel: "1",
      freeWithdrawalCount: "2",
      upgradeBonus: "0",
      dailyWithdrawalLimit: "∞",
      birthdayBonus: "0",
      capsuleTicket: "10",
      maxRebate: "0.8",
      deposit_max: "5000000",
      wash_max: "32000000",
    },
    {
      vipLevel: "2",
      freeWithdrawalCount: "3",
      upgradeBonus: "0.7",
      dailyWithdrawalLimit: "∞",
      birthdayBonus: "0",
      capsuleTicket: "100",
      maxRebate: "0.8",
      deposit_max: "15000000",
      wash_max: "320000000",
    },
    {
      vipLevel: "3",
      freeWithdrawalCount: "3",
      upgradeBonus: "2",
      dailyWithdrawalLimit: "∞",
      birthdayBonus: "0",
      capsuleTicket: "1000",
      maxRebate: "0.8",
      deposit_max: "45000000",
      wash_max: "960000000",
    },
    {
      vipLevel: "4",
      freeWithdrawalCount: "4",
      upgradeBonus: "6",
      dailyWithdrawalLimit: "∞",
      birthdayBonus: "2",
      capsuleTicket: "10000",
      maxRebate: "0.8",
      deposit_max: "100000000",
      wash_max: "2250000000",
    },
    {
      vipLevel: "5",
      freeWithdrawalCount: "5",
      upgradeBonus: "10",
      dailyWithdrawalLimit: "∞",
      birthdayBonus: "5",
      capsuleTicket: "100000",
      maxRebate: "0.8",
      deposit_max: "200000000",
      wash_max: "5000000000",
    },
  ];
  const customVipList = VipList;
  const combineVip = mockData.map((vip, index) => {
    const findVip = customVipList.find((item) => {
      return item.level == vip.vipLevel;
    });

    const {
      freeWithdrawalCount,
      upgradeBonus,
      birthdayBonus,
      maxRebate,
      deposit_max,
      wash_max,
    } = vip;

    return {
      ...findVip,
      freeWithdrawalCount,
      upgradeBonus,
      birthdayBonus,
      maxRebate,
      deposit_max,
      wash_max,
    };
  });

  return {
    type: "storeVipDetail",
    payload: [customVipList[0], ...combineVip],
  };
};
export const clearTransferWallet = () => {
  return {
    type: "clearTransferWallet",
  };
};
export const openGameDescriptionPop = ({ game } = {}) => {
  return {
    type: "openGameDescriptionPop",
    payload: {
      state: true,
      game,
    },
  };
};
export const closeGameDescriptionPop = () => {
  return {
    type: "closeGameDescriptionPop",
  };
};
export const storeInboxDetail = (data) => {
  return {
    type: "storeInboxDetail",
    payload: data,
  };
};
export const openChat = () => {
  return {
    type: "openChat",
  };
};
export const closeChat = () => {
  return {
    type: "closeChat",
  };
};
export const triggerGameBoxTransfer = () => {
  return {
    type: "triggerGameBoxTransfer",
  };
};
export const closeGameBoxTransfer = () => {
  return {
    type: "closeGameBoxTransfer",
  };
};
export const storeMarqueeList = (data) => {
  return {
    type: "storeMarqueeList",
    payload: data,
  };
};
export const clearMarqueeList = () => {
  return {
    type: "clearMarqueeList",
  };
};
export const openCache = () => {
  return {
    type: "openCache",
  };
};
export const closeCache = () => {
  return {
    type: "closeCache",
  };
};

export const storeInboxList = (data) => {
  return {
    type: "storeInboxList",
    payload: data,
  };
};
